export default __webpack_public_path__ + "static/media/profile-codau.cd3f0ae1.jpeg";